<!-- v1.5 - in use -->

<template>
  <div class="loading" v-if="loading && !error">
    <loadingAnimation />
  </div>

  <div v-else id="pdpDdabc">
    <div class="ctpx-pdp-dd-intro d-none d-md-block">
      <div
        class="bg"
        :style="{
          backgroundImage: 'url(' + ddProduct.headerImageDesktop + ')',
        }"
      >
        <div class="container">
          <div class="row">
            <div class="col-md-7 col-lg-6 text-left">
              <div v-if="urlContains('upcycled-jacket')">
                <h1>One-of-One Renovo Jackets</h1>
              </div>
              <div v-else-if="urlContains('upcycled-vest')">
                <h1>One-of-One Renovo Vests</h1>
              </div>
            </div>
            <!-- .col -->
          </div>
          <!-- .row -->
          <div class="row justify-content-left">
            <div class="col-md-7 col-lg-6 text-left">
              <div v-if="urlContains('upcycled-jacket')">
                <p class="lead">
                  Made by upcycling pre-loved Cotopaxi outerwear
                </p>
              </div>
              <div v-else-if="urlContains('upcycled-vest')">
                <p class="lead">
                  Fleece vests made from pre-loved Cotopaxi outerwear
                </p>
              </div>
            </div>
            <!-- .col -->
          </div>
          <!-- .row -->
        </div>
        <!--.container-->
        <div v-if="urlContains('upcycled-jacket')" class="model-info">
          <span class="small-print"
            >Nicolás is 6'1" and wearing size L/XL
          </span>
        </div>
        <div v-else-if="urlContains('upcycled-vest')" class="model-info">
          <span class="small-print"
            >Magdalena is 5'9" and wearing size S/M</span
          >
        </div>
      </div>
      <!--.bg-->
    </div>
    <!-- ctpx-pdp-ddc-intro -->

    <div class="ctpx-pdp-dd-intro mobile-only">
      <div
        class="bg"
        :style="{ backgroundImage: 'url(' + ddProduct.headerImageMobile + ')' }"
      >
        <div class="row">
          <div class="col-10 text-left">
            <div v-if="urlContains('upcycled-jacket')">
              <h1>One-of-One Renovo Jackets</h1>
            </div>
            <div v-else-if="urlContains('upcycled-vest')">
              <h1>One-of-One Renovo Vests</h1>
            </div>
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
        <div class="row">
          <div class="col-10 text-left">
            <div v-if="urlContains('upcycled-jacket')">
              <p class="lead">Made by upcycling pre-loved Cotopaxi outerwear</p>
            </div>
            <div v-else-if="urlContains('upcycled-vest')">
              <p class="lead">
                Fleece vests made from pre-loved Cotopaxi outerwear
              </p>
            </div>
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
        <div v-if="urlContains('upcycled-jacket')" class="model-info">
          <span class="small-print"
            >Nicolás is 6'1" and wearing size L/XL
          </span>
        </div>
        <div v-else-if="urlContains('upcycled-vest')" class="model-info">
          <span class="small-print"
            >Magdalena is 5'9" and wearing size S/M</span
          >
        </div>
      </div>
      <!--.bg-->
    </div>
    <!-- ctpx-pdp-ddc-intro -->

    <div class="ctpx-details-wrapper" :class="{ 'surprise-me': isSurprise }">
      <div class="ctpx-pdp-details ctpx-pdp-details-ddc">
        <div class="row g-0">
          <div
            class="col-12 col-md-auto col-lg-8 order-lg-1 justify-content-sm-center justify-content-md-start"
          >
            <!-- ==================== Del Dia Color Box ==================== -->
            <div class="del-dia-box colors" ref="box-title">
              <div
                class="row d-flex color-swatches flex-row-center justify-content-sm-center justify-content-md-start"
              >
                <div
                  v-if="
                    choiceProducts.some(
                      (x) =>
                        x.color === Colors.red ||
                        x.color === Colors.brightRed ||
                        x.color === Colors.pink
                    )
                  "
                  class="col-auto"
                >
                  <div @click="goto('box-title')" class="dd-color-family">
                    <input
                      type="checkbox"
                      id="radio-red"
                      name="radioColor"
                      value="red"
                      v-model="filteredColors"
                    />
                    <label for="radio-red"
                      ><span style="background-color: #f52d2d">Red</span></label
                    >
                  </div>
                  <!-- .dd-color-family -->
                </div>
                <!-- .col -->
                <div
                  v-if="choiceProducts.some((x) => x.color === Colors.orange)"
                  class="col-auto"
                >
                  <div @click="goto('box-title')" class="dd-color-family">
                    <input
                      type="checkbox"
                      id="radio-orange"
                      name="radioColor"
                      value="orange"
                      v-model="filteredColors"
                    />
                    <label for="radio-orange"
                      ><span style="background-color: #ff9018"
                        >Orange</span
                      ></label
                    >
                  </div>
                  <!-- .dd-color-family -->
                </div>
                <!-- .col -->
                <div
                  v-if="
                    choiceProducts.some(
                      (x) =>
                        x.color === Colors.yellow ||
                        x.color === Colors.brightYellow
                    )
                  "
                  class="col-auto"
                >
                  <div @click="goto('box-title')" class="dd-color-family">
                    <input
                      type="checkbox"
                      id="radio-yellow"
                      name="radioColor"
                      value="yellow"
                      v-model="filteredColors"
                    />
                    <label for="radio-yellow"
                      ><span style="background-color: #f5c853"
                        >Yellow</span
                      ></label
                    >
                  </div>
                  <!-- .dd-color-family -->
                </div>
                <!-- .col -->
                <div
                  v-if="
                    choiceProducts.some(
                      (x) =>
                        x.color === Colors.green ||
                        x.color === Colors.darkGreen ||
                        x.color === Colors.limeGreen
                    )
                  "
                  class="col-auto"
                >
                  <div @click="goto('box-title')" class="dd-color-family">
                    <input
                      type="checkbox"
                      id="radio-green"
                      name="radioColor"
                      value="green"
                      v-model="filteredColors"
                    />
                    <label for="radio-green"
                      ><span style="background-color: #326957"
                        >Green</span
                      ></label
                    >
                  </div>
                  <!-- .dd-color-family -->
                </div>
                <!-- .col -->
                <div
                  v-if="
                    choiceProducts.some(
                      (x) =>
                        x.color === Colors.blue ||
                        x.color === Colors.darkBlue ||
                        x.color === Colors.teal ||
                        x.color === Colors.lightBlue
                    )
                  "
                  class="col-auto"
                >
                  <div @click="goto('box-title')" class="dd-color-family">
                    <input
                      type="checkbox"
                      id="radio-blue"
                      name="radioColor"
                      value="blue"
                      v-model="filteredColors"
                    />
                    <label for="radio-blue"
                      ><span style="background-color: #0098db"
                        >Blue</span
                      ></label
                    >
                  </div>
                  <!-- .dd-color-family -->
                </div>
                <!-- .col -->
                <div
                  v-if="choiceProducts.some((x) => x.color === Colors.purple)"
                  class="col-auto"
                >
                  <div @click="goto('box-title')" class="dd-color-family">
                    <input
                      type="checkbox"
                      id="radio-purple"
                      name="radioColor"
                      value="purple"
                      v-model="filteredColors"
                    />
                    <label for="radio-purple"
                      ><span style="background-color: #7f84c6"
                        >Purple</span
                      ></label
                    >
                  </div>
                  <!-- .dd-color-family -->
                </div>
                <!-- .col -->
                <div
                  v-if="
                    choiceProducts.some(
                      (x) =>
                        x.color === Colors.black ||
                        x.color === Colors.white ||
                        x.color === Colors.gray
                    )
                  "
                  class="col-auto"
                >
                  <div @click="goto('box-title')" class="dd-color-family">
                    <input
                      type="checkbox"
                      id="radio-black"
                      name="radioColor"
                      value="gray"
                      v-model="filteredColors"
                    />
                    <label for="radio-black"
                      ><span style="background-color: gray">Gray</span></label
                    >
                  </div>
                </div>
                <!-- .col -->
                <div
                  v-if="choiceProducts.some((x) => x.color === Colors.brown)"
                  class="col-auto"
                >
                  <div @click="goto('box-title')" class="dd-color-family">
                    <input
                      type="checkbox"
                      id="radio-brown"
                      name="radioColor"
                      value="brown"
                      v-model="filteredColors"
                    />
                    <label for="radio-brown"
                      ><span style="background-color: brown">Brown</span></label
                    >
                  </div>
                  <!-- .dd-color-family -->
                </div>
                <!-- .col -->
                <div v-if="filteredColors.length >= 2" class="col-auto">
                  <div @click="goto('box-title')" class="dd-color-family all">
                    <button @click="clearColorFilters()" class="btn btn-black">
                      View All Colors
                    </button>
                  </div>
                  <!-- .dd-color-family -->
                </div>
                <!-- .col -->
                <div class="col-auto del-dia-box sizes">
                  <div v-if="urlContains('upcycled-jacket-sm-md')">
                    <a href="#" class="btn new disabled">Small/Medium</a>
                    <a
                      href="/products/renovo-upcycled-jacket-lg-xl"
                      class="btn new"
                      >Large/Extra Large</a
                    >
                  </div>
                  <div v-else-if="urlContains('upcycled-jacket-lg-xl')">
                    <a
                      href="/products/renovo-upcycled-jacket-sm-md"
                      class="btn new"
                      >Small/Medium</a
                    >
                    <a href="#" class="btn new disabled">Large/Extra Large</a>
                  </div>
                  <div v-else-if="urlContains('upcycled-vest-sm-md')">
                    <a href="#" class="btn new disabled">Small/Medium</a>
                    <a
                      href="/products/renovo-upcycled-vest-lg-xl"
                      class="btn new"
                      >Large/Extra Large</a
                    >
                  </div>
                  <div v-else-if="urlContains('upcycled-vest-lg-xl')">
                    <a
                      href="/products/renovo-upcycled-vest-sm-md"
                      class="btn new"
                      >Small/Medium</a
                    >
                    <a href="#" class="btn new disabled">Large/Extra Large</a>
                  </div>
                </div>
              </div>
              <!-- .row  -->
            </div>
          </div>
          <!--.col-->
          <!-- del-dia-box -->
          <div
            class="col-12 col-md col-lg-4 order-lg-3 d-flex justify-content-center justify-content-lg-end"
          >
            <!-- ==================== Del Dia Refresh Button ==================== -->
            <div class="del-dia-box favorites" v-if="!isSurprise">
              <img
                @click="refreshGrid(), rotateBtn()"
                src="https://cdn.shopify.com/s/files/1/0281/7544/files/refresh.svg"
                loading="lazy"
                alt="refresh grid"
                class="refresh-grid"
                style="width: 30px"
                id="refreshBtn"
              />
              <img
                v-if="!showFullHeart"
                @click="filterFavorites(), (showFullHeart = !showFullHeart)"
                src="https://cdn.shopify.com/s/files/1/0281/7544/files/fav.svg"
                loading="lazy"
                alt="favorite icon"
                class="favorite"
                style="width: 30px"
              />
              <img
                v-else
                @click="filterFavorites(), (showFullHeart = !showFullHeart)"
                src="https://cdn.shopify.com/s/files/1/0281/7544/files/fav-full.svg"
                loading="lazy"
                alt="favorite icon"
                class="favorite"
                style="width: 30px"
              />
            </div>
            <!-- del-dia-box -->
          </div>
          <!--.col-->
        </div>
        <!--.row-->
        <!-- ==================== Del Dia Choose Box ==================== -->
        <div class="del-dia-box col choose" id="anchor-choice">
          <delDiaSlide
            :product="selectedVariant"
            :abVersion="abVersion"
            :productId="productId"
            :accordionContent="accordionContent"
            :lifestyleImgs="lifestyleImgs"
            :delDiaApparel="delDiaApparel"
          ></delDiaSlide>
          <div class="row">
            <div class="col">
              <div class="dd-choices ddc">
                <div class="dd-choices-grid">
                  <div class="row flex-row">
                    <div
                      v-if="filteredChoices.length == 0 && !showFullHeart"
                      class="col text-center"
                    >
                      <h1>Sold Out</h1>
                    </div>
                    <div
                      v-else-if="filteredChoices.length == 0 && showFullHeart"
                      class="col text-center"
                    >
                      <h4>
                        You haven't selected any favorites yet.
                        <a @click="clearColorFilters()" class="btn btn-link"
                          >Start Favoriting!</a
                        >
                      </h4>
                    </div>
                  </div>
                  <!--.row-->
                  <div class="row">
                    <div
                      class="col-6 col-md-4 col-lg-3 choice-grid-item"
                      v-for="product in filteredChoices.slice(0, 48)"
                      :key="product.src"
                    >
                      <img
                        v-if="!product.favorite"
                        @click="toggleFavorite(product)"
                        src="https://cdn.shopify.com/s/files/1/0281/7544/files/fav.svg"
                        loading="lazy"
                        alt="favorite icon"
                        class="favorite"
                      />
                      <img
                        v-else
                        @click="toggleFavorite(product)"
                        src="https://cdn.shopify.com/s/files/1/0281/7544/files/fav-full.svg"
                        loading="lazy"
                        alt="favorite icon"
                        class="favorite"
                      />
                      <div
                        @click="selectVariant(product), openSlide()"
                        class="dd-choice-image"
                        :class="{ active: selectedVariant === product }"
                      >
                        <img
                          :src="
                            product.images[0].src.replace('w_1024', 'w_350')
                          "
                          :srcset="
                            product.images[0].src.replace('w_1024', 'w_700') +
                            ' 2x'
                          "
                          itemprop="image"
                        />
                        <img
                          :src="
                            product.images[1].src.replace('w_1024', 'w_350')
                          "
                          :srcset="
                            product.images[1].src.replace('w_1024', 'w_700') +
                            ' 2x'
                          "
                          itemprop="image"
                          class="hoverShow"
                        />
                        <span v-if="product.viewed" class="viewed-tag display-6"
                          >Viewed</span
                        >
                      </div>
                      <!-- .dd-choice-image -->
                    </div>
                  </div>
                  <!-- .row -->
                </div>
                <!-- .dd-choices-grid -->
              </div>
              <!-- .dd-choices -->
            </div>
            <!-- col -->
          </div>
          <!-- .row -->
        </div>
        <!-- del-dia-box -->
      </div>
      <!-- ctpx-pdp-details -->
    </div>
    <!-- ctpx-details-wrapper -->

    <div class="ctpx-pdp-images ctpx-pdp-images-ddc" id="ddpdpImagesC">
      <div class="row" id="anchor-features">
        <div class="col text-center">
          <h1>Product Features</h1>
        </div>
        <!-- .col -->
      </div>
      <!-- .row -->
      <div class="row mobile-hidden image-grid-row">
        <div
          class="col-sm-6 img-mapper-container"
          v-for="(img, i) in pinContent"
          :key="img.src"
        >
          <div class="img-mapper">
            <img
              :src="img.image.replace('upload', 'upload/w_700')"
              :srcset="img.image.replace('upload', 'upload/w_1100') + ' 2x'"
              alt="details"
              class="img-fluid lazy-load"
            />
            <div
              v-for="(pin, ii) in img.pins.filter((x) => x.description)"
              class="map-pin"
              :style="'top:' + pin.yPosition + '%;left:' + pin.xPosition + '%;'"
              :class="{ active: activePin === i + '' + ii }"
            >
              <a class="pin-point" @click="activatePin(i + '' + ii)">+</a>
              <span class="pin-content">{{ pin.description }}</span>
            </div>
            <!-- .map-pin -->
          </div>
          <!-- .img-mapper -->
        </div>
        <!-- .col-sm-6 -->
        <div class="col-sm-6 img-mapper-container" v-if="!ddProduct.imageMaps">
          <div class="img-mapper">
            <img
              :src="
                ddProduct.images[0].src.includes('png')
                  ? ddProduct.images[0].src.replace('.png', '_700x.png')
                  : ddProduct.images[0].src.includes(jpg)
                  ? ddProduct.images[0].src.replace('.jpg', '_700x.jpg')
                  : ddProduct.images[0].src
              "
              :srcset="
                ddProduct.images[0].src.includes('png')
                  ? ddProduct.images[0].src.replace('.png', '_1100x.png')
                  : ddProduct.images[0].src.includes(jpg)
                  ? ddProduct.images[0].src.replace('.jpg', '_1100x.jpg')
                  : ddProduct.images[0].src + ' 2x'
              "
              :alt="ddProduct.images[0].alt"
              class="img-fluid lazy-load"
            />
          </div>
          <!-- .img-mapper -->
        </div>
        <!-- .col-sm-6 -->
        <div class="col-sm-6 accordion-slide">
          <!-- ==================== accordion-box ==================== -->
          <div class="accordion-box">
            <div
              class="accordion-item"
              v-for="(accordion, index) in accordionContent"
              :class="{ active: activeDrawer === index }"
              :key="accordion.title"
            >
              <div class="accordion-header" @click="activateAccordion(index)">
                <h4>{{ accordion.title }}</h4>
              </div>
              <!-- accordion-header -->
              <div class="accordion-content">
                <div v-html="accordion.content"></div>
              </div>
              <!-- accordion-content -->
            </div>
            <!-- .accordion-item -->
          </div>
          <!-- .accordion-box -->
        </div>
        <!-- .col-sm-6 -->
      </div>
      <!-- .row -->

      <div class="row ctpx-carousel image-grid-row">
        <swiper
          :modules="modules"
          :slides-per-view="1"
          :space-between="50"
          :lazy="true"
          :zoom="true"
          navigation
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
          <swiper-slide
            class="ctpx-slide img-mapper-container"
            v-for="(img, index) in pinContent"
            :id="'img2' + index"
            :key="img.image"
          >
            <div class="img-mapper">
              <div class="swiper-zoom-container">
                <img
                  :src="img.image.replace('upload', 'upload/w_700')"
                  :srcset="img.image.replace('upload', 'upload/w_1100') + ' 2x'"
                  alt="details"
                  class="img-fluid lazy-load"
                  draggable="false"
                />
                <div
                  v-for="(pin, ii) in img.pins.filter((x) => x.description)"
                  class="map-pin"
                  :style="
                    'top:' + pin.yPosition + '%;left:' + pin.xPosition + '%;'
                  "
                  :class="{ active: activePin === index + '' + ii }"
                >
                  <a class="pin-point" @click="activatePin(index + '' + ii)"
                    >+</a
                  >
                  <span class="pin-content">{{ pin.description }}</span>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide
            v-if="!ddProduct.imageMaps"
            class="ctpx-slide"
            v-for="(img, index) in ddProduct.images"
            :id="'img2' + index"
            :key="img.src"
          >
            <img
              :src="
                img.src.includes('png')
                  ? img.src.replace('.png', '_750x.png')
                  : img.src.includes(jpg)
                  ? img.src.replace('.jpg', '_750x.jpg')
                  : img.src
              "
              :srcset="
                img.src.includes('png')
                  ? img.src.replace('.png', '_1100x.png')
                  : img.src.includes(jpg)
                  ? img.src.replace('.jpg', '_1100x.jpg')
                  : img.src + ' 2x'
              "
              :alt="img.alt"
              class="img-fluid swiper-lazy"
              draggable="false"
            />
          </swiper-slide>
        </swiper>
      </div>
      <!-- ctpx-carousel -->

      <!-- ==================== accordion-box ==================== -->
      <div class="row accordion-box mobile-only">
        <div
          class="accordion-item"
          v-for="(accordion, index) in accordionContent"
          :class="{ active: activeDrawer === index }"
          :key="accordion.title"
        >
          <div class="accordion-header" @click="activateAccordion(index)">
            <h4>{{ accordion.title }}</h4>
          </div>
          <!-- accordion-header -->
          <div class="accordion-content">
            <div v-html="accordion.content"></div>
          </div>
          <!-- accordion-content -->
        </div>
        <!-- .accordion-item -->
      </div>
      <!-- .accordion-box -->
    </div>
    <!-- .ctpx-pdp-images -->
  </div>
  <!-- pdpDdaba -->
</template>

<script src="./ctrl-pdp-del-dia-apparel.js"></script>
